<template>
	<div class="home-header">
		<div class="home-header-container">
			<img
				class="logo"
				src="https://oss.cuttlefish.vip/file/h5upload/178884522481666349681.png"
				@click="routerJump('/')"
			/>
			<button
				class="menu-btn"
				:class="{ opened }"
				type="button"
				aria-label="切换导航菜单"
				@click="opened = !opened"
			>
				<span></span>
				<span></span>
				<span></span>
			</button>
		</div>
		<div class="nav-menu" v-show="opened">
			<div v-for="(menu, index) in menuList" :key="index">
				<div
					class="nav-menu-item"
					:class="{ active: isMenuActive(menu) }"
					@click="menu.children ? (companyOpened = !companyOpened) : routerJump(menu.path)"
				>
					{{ menu.name }}
					<span v-if="menu.children" class="menu-arrow" :class="{ opened: companyOpened }"></span>
				</div>
				<div v-if="menu.children && companyOpened" class="nav-submenu">
					<div
						v-for="child in menu.children"
						:key="child.id"
						class="nav-submenu-item"
						:class="{ active: path === child.path }"
						@click="routerJump(child.path)"
					>
						{{ child.name }}
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script setup>
	export default {
		data() {
			return {
				menuList: [
					{ id: 1, name: "首页", path: "/home" },
					{ id: 2, name: "定制游", path: "/customTour" },
					{ id: 3, name: "驴友社区", path: "/travelCommunity" },
					{ id: 4, name: "组队", path: "/goWith" },
					{ id: 5, name: "热门路线", path: "/hotRoute" },
					{ id: 6, name: "关于墨鱼", path: "/appDownload" },
					{
						id: 7,
						name: "公司介绍",
						children: [
							{ id: 71, name: "平台介绍", path: "/platformIntro" },
							{ id: 72, name: "创始人介绍", path: "/founderIntro" },
						],
					},
				],
				opened: false,
				companyOpened: false,
				path: this.$route.path,
			};
		},
		methods: {
			routerJump(path) {
				this.$router.push(path);
				this.opened = false;
				this.companyOpened = false;
			},
			isMenuActive(menu) {
				if (menu.path) {
					return this.path === menu.path;
				}
				return menu.children && menu.children.some((child) => child.path === this.path);
			},
		},
		watch: {
			$route(route) {
				this.path = route.path;
			},
		},
	};
</script>
<style scoped lang="scss">
	.home-header {
		z-index: 1000;
		width: 100%;
		background-color: #ffffff;
		color: #3d3d3d;
		box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.08),
			0px 0px 100px 5px rgba(0, 0, 0, 0.16);

		.home-header-container {
			max-width: 1440px;
			display: flex;
			align-items: center;
			padding: 21px 16px;
			box-sizing: border-box;
			margin: 0 auto;
			z-index: 1000;
			justify-content: space-between;
			height: 64px;
			box-sizing: border-box;
			.logo {
				height: 32px;
				width: auto;
			}
			.menu-btn {
				position: relative;
				padding: 0;
				width: 28px;
				height: 24px;
				border: 0;
				background: transparent;
				outline: none;

				span {
					position: absolute;
					left: 2px;
					display: block;
					width: 24px;
					height: 2px;
					border-radius: 1px;
					background: #333;
					transition: transform 0.2s ease, opacity 0.2s ease;

					&:nth-child(1) {
						top: 4px;
					}

					&:nth-child(2) {
						top: 11px;
					}

					&:nth-child(3) {
						top: 18px;
					}
				}

				&.opened span {
					&:nth-child(1) {
						top: 11px;
						transform: rotate(45deg);
					}

					&:nth-child(2) {
						opacity: 0;
					}

					&:nth-child(3) {
						top: 11px;
						transform: rotate(-45deg);
					}
				}
			}
		}

		.nav-menu {
			position: absolute;
			top: 63px;
			background-color: #ffffff;
			width: 100%;
			z-index: 99;
			.nav-menu-item {
				display: flex;
				justify-content: center;
				align-items: center;
				width: 100%;
				text-align: center;
				box-sizing: border-box;
				font-size: 12px;
				font-weight: 500;
				line-height: normal;
				letter-spacing: 0em;
				font-feature-settings: "kern" on;
				color: #3d3d3d;
				margin-bottom: 20px;

				&.active {
					color: #26a1ff;
				}

				.menu-arrow {
					margin: -3px 0 0 8px;
					width: 6px;
					height: 6px;
					border-right: 1px solid currentColor;
					border-bottom: 1px solid currentColor;
					transform: rotate(45deg);

					&.opened {
						margin-top: 3px;
						transform: rotate(225deg);
					}
				}
			}

			.nav-submenu {
				margin: -8px 20px 20px;
				padding: 8px 0;
				border-radius: 8px;
				background: #f5f9fc;

				.nav-submenu-item {
					padding: 10px 0;
					font-size: 12px;
					color: #666;
					text-align: center;

					&.active {
						color: #26a1ff;
					}
				}
			}
		}
	}
</style>
